import { getStoredMarket, marketToCountry } from "@/i18n/markets";

const PHONE_EXAMPLES: Record<string, string> = {
  US: "+1 555 123 4567",
  CA: "+1 555 123 4567",
  GB: "+44 7700 900123",
  IE: "+353 85 123 4567",
  AU: "+61 412 345 678",
  NZ: "+64 21 123 4567",
  ZA: "+27 82 123 4567",
  DE: "+49 1512 3456789",
  FR: "+33 6 12 34 56 78",
  ES: "+34 612 34 56 78",
  IT: "+39 312 345 6789",
  PT: "+351 912 345 678",
  DK: "+45 20 12 34 56",
  SE: "+46 70 123 45 67",
  NO: "+47 406 12 345",
  MT: "+356 99… … …",
  BR: "+55 11 91234 5678",
  MX: "+52 55 1234 5678",
  CO: "+57 300 … … …",
  EC: "+593 99 … … …",
  BE: "+32 470 … … …",
  PL: "+48 512 … … …",
  SK: "+421 901 … … …",
  BG: "+359 88 … … …",
  FI: "+358 40 … … …",
  NL: "+31 6 … … …",
};

function validCountry(value?: string | null): string | null {
  const country = value?.trim().toUpperCase();
  return country && /^[A-Z]{2}$/.test(country) ? country : null;
}

function countryFromLocale(locale?: string | null): string | null {
  if (!locale) return null;
  const region = locale.replace("_", "-").split("-")[1];
  return validCountry(region);
}

export function getPhoneExample(options: {
  explicitMarket?: string | null;
  visitorCountry?: string | null;
  locale?: string | null;
  browserLocale?: string | null;
} = {}): string {
  const urlMarket = typeof window !== "undefined"
    ? window.location.pathname.split("/").filter(Boolean).find((part) => part in {
        uk: true, ie: true, us: true, ca: true, au: true, nz: true, za: true,
        de: true, fr: true, es: true, it: true, pt: true, dk: true, se: true,
        mt: true, br: true, co: true, ec: true, mx: true, be: true, pl: true,
        sk: true, no: true, bg: true, fi: true, nl: true,
      })
    : undefined;
  const country = validCountry(
    (urlMarket && marketToCountry(urlMarket))
      || (options.explicitMarket && marketToCountry(options.explicitMarket))
      || (getStoredMarket() && marketToCountry(getStoredMarket()))
      || options.visitorCountry
      || countryFromLocale(options.locale)
      || countryFromLocale(options.browserLocale),
  );
  return (country && PHONE_EXAMPLES[country]) || "+[country code] [phone number]";
}